module.exports = __webpack_public_path__ + "img/delete-file-icon.90f32870.svg";